var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseRoof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.643 10.59L11.692 3.107C11.8707 2.95907 12.1293 2.95907 12.308 3.107L21.357 10.59C21.6581 10.8401 22.0477 10.9577 22.4369 10.9159C22.8262 10.8741 23.1819 10.6764 23.423 10.368C23.9333 9.72119 23.8367 8.78589 23.205 8.257L14.156 0.774C12.904 -0.258316 11.096 -0.258316 9.844 0.774L0.800004 8.257C0.168341 8.78589 0.0717532 9.72119 0.582004 10.368C0.823358 10.6744 1.17799 10.8707 1.56581 10.9125C1.95363 10.9542 2.34193 10.838 2.643 10.59Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.281 22V15C22.2642 14.3921 21.9993 13.8176 21.548 13.41L13.248 6.41C12.5281 5.80115 11.4739 5.80115 10.754 6.41L2.454 13.416C2.00329 13.8217 1.7378 14.3939 1.719 15V22C1.70844 23.0925 2.58447 23.9874 3.677 24H9.063C9.60938 23.994 10.0475 23.5464 10.042 23V17.5C10.037 16.9538 10.4748 16.5066 11.021 16.5H12.979C13.5251 16.5066 13.963 16.9538 13.958 17.5V23C13.9524 23.5464 14.3906 23.994 14.937 24H20.323C21.4155 23.9874 22.2915 23.0925 22.281 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseRoof);
export default __webpack_public_path__ + "static/media/houseRoof.4ef714a1.svg";
export { ForwardRef as ReactComponent };